import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig from "./SEOConfig";

// Head tags for private or transient pages (settings, registration, the OAuth callback). They are
// also Disallowed in robots.txt; the noindex covers a URL that gets indexed through an external
// link anyway. The canonical is self-referencing for the same reason as NotFoundSEO: SEO.jsx
// falls back to the site root, which would claim the page duplicates the home page.
const NoIndexSEO = ({ title }) => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  return (
    <SEO
      title={title}
      url={currentUrl}
      canonical={currentUrl}
      robots="noindex, nofollow"
      type="website"
      lang="uk"
    />
  );
};

export default NoIndexSEO;
